import { Global } from "../Shared/Global"

class GameList {
    private _serverData: {} = null

    set serverData (value) {
        this._serverData = value

        for (let i = 0; i < this._serverData["tabList"].length; i++) {
            const cfg = this._serverData["tabList"][i];
            // 特殊处理，因为之前体育和电竞是同一个分类
            if (cfg["gameTypes"] && cfg["gameTypes"].indexOf(",") !== -1) {
                let sports = {}
                let eSports = {}
                let games = []

                this._serverData["tabList"].push(JSON.parse(JSON.stringify(cfg)))
                eSports = this._serverData["tabList"][this._serverData["tabList"].length - 1]
                eSports["gameTypes"] = Global.GameType.ESport.toString()
                cfg["gameTypes"] = Global.GameType.Sport.toString()
                sports = cfg
                games = JSON.parse(JSON.stringify(sports["twoLevelList"]))

                sports["twoLevelList"] = []
                eSports["twoLevelList"] = []
                games.forEach(game => {
                    if (game["platformGameType"] === 6) {
                        sports["twoLevelList"].push(JSON.parse(JSON.stringify(game)))
                    }else {
                        eSports["twoLevelList"].push(JSON.parse(JSON.stringify(game)))
                    }
                });
                break
            }
        }
        
        cc.director.emit(Global.UserEvent.GameListChanged)
    }
    
    get serverData () {
        return this._serverData
    }

    /**
     * 获取指定游戏类型的游戏列表
     * @param type
     */
    getGameListByType (type) {
        let data = {}

        for (let i = 0; i < this.serverData["tabList"].length; i++) {
            const cfg = this.serverData["tabList"][i];
            if (cfg["gameTypes"] === type.toString()) {
                data = cfg
                break
            }
        }

        return data
    }

    getGameConfigById(typeId,gamePlat){//必须排除热门游戏；
        let gameConfig = null;
        let tabList = this._serverData["tabList"];
        cc.log("====typeId:%s,gamePlat:%s",typeId,gamePlat);
        cc.log("====获取gameConfig  tabList:",tabList);
        for (let i = 0;i < tabList.length;i++){
            if (tabList[i].gameTypes === "") continue;//热门游戏排除
            let twoLevelList = tabList[i].twoLevelList;
            for (let j = 0;j < twoLevelList.length;j++){
                if (twoLevelList[j].platformGameType != typeId){
                    continue;
                }else if (twoLevelList[j].platform === gamePlat){
                    gameConfig = twoLevelList[j];
                    return gameConfig;
                }
            }
        }
        return gameConfig;
    }

    getCategoryNameByTypeId(typeId){
        let tabList = this._serverData["tabList"];
        for (let i = 0;i < tabList.length;i++){
            let twoLevelList = tabList[i].twoLevelList;
            for (let j = 0;j < twoLevelList.length;j++){
                if (twoLevelList[j].platformGameType === typeId){
                    return tabList[i].categoryName;
                }
            }
        }

    }


}

export default new GameList()